export default __webpack_public_path__ + "static/poncho-4576bc779b6d1c271b759bea15ce3b6c.jpg";